export default "__VITE_ASSET__C$Osnmf4__"